import { motion } from "framer-motion";
import { PHILOSOPHY } from "../data";

export const Philosophy = () => {
  return (
    <section
      id="filosofie"
      data-testid="philosophy-section"
      className="relative z-10 py-28 md:py-40 px-6 overflow-hidden"
    >
      <div
        className="absolute inset-0 z-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1577344718665-3e7c0c1ecf6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 z-0 bg-[#06040A]/80" />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D6B56D] mb-8">
            Spiritual philosophy
          </p>
          <blockquote className="font-heading font-light italic text-3xl md:text-5xl text-[#EBE4D8] leading-snug max-w-3xl mx-auto">
            "We are not human beings having a spiritual experience. We are
            spiritual beings having a human experience."
          </blockquote>
        </motion.div>

        <div className="mt-20">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-heading text-3xl md:text-4xl text-[#EBE4D8] mb-10"
          >
            My values...
          </motion.h3>
          <div className="grid md:grid-cols-3 gap-6">
          {PHILOSOPHY.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`philosophy-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className="backdrop-blur-xl bg-[#120E1A]/60 border border-[#D6B56D]/20 rounded-2xl p-8 text-left hover:border-[#D6B56D]/50 transition-colors duration-500"
            >
              <div className="font-heading text-5xl text-[#D6B56D]/40 mb-4">
                0{i + 1}
              </div>
              <h3 className="font-heading text-2xl text-[#EBE4D8] mb-3">
                {p.title}
              </h3>
              <p className="text-[#A59DAB] leading-relaxed font-light">
                {p.text}
              </p>
            </motion.div>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
};
